import Image from "next/image";
import Link from 'next/link';
import GenericMaleThumbnail from "../../../../public/images/thumbs-generic-male-1.png";
import arrowPrev from "../../../../public/images/icons/arrow-prev.png";
import arrowNext from "../../../../public/images/icons/arrow-next.png";
import CandidateSocialButtons from "./CandidateSocialButtons";
import styles from "../../../styles/candidate/parts/CandidateTestimonialSection.module.scss";

const CandidateTestimonialSection = ({
  data,
  headline,
  type,
  anchor,
  url
}) => {

  const loader = ({ src, width, quality }) => {
    const imageUrl = process.env.SITE_URL;
    return `${imageUrl}${src}?w=${width}&q=${quality || 75}`;
  };

  const scroll = (type, dir) => {
    const element = document.getElementById(`${type}Carousel`);
    const dataLength = data.quotes?.length || data.gaffes?.length;
    const scrollLeap = Math.ceil(document.getElementById(`${type}Carousel`).scrollWidth / Math.ceil(dataLength / 4));
    const scrollWidth = document.getElementById(`${type}Carousel`).scrollWidth;
    const currentScrollPosition = document.getElementById(`${type}Carousel`).scrollLeft;

    if (element) {
      if (dir === 'left') {
        if (currentScrollPosition === 0) {
          document.getElementById(`${type}Carousel`).scrollLeft = scrollWidth;
        } else {
          document.getElementById(`${type}Carousel`).scrollLeft -= (scrollLeap - 10);
        }
      } else {
        if (currentScrollPosition + scrollLeap >= scrollWidth - 10) {
          document.getElementById(`${type}Carousel`).scrollLeft = 0;
        } else {
          document.getElementById(`${type}Carousel`).scrollLeft += (scrollLeap - 10);
        }
      }
    } 
  };

  return data && (data.quotes?.length || data.gaffes?.length) ? (
    <div id={anchor} className={`${styles.candidateTestimonialSectionWrapper} ${type === 'quotes' ? styles.quoteSection : styles.gaffesAndBlundersSection}`}>
      <div className={styles.candidatesTestimonialHeader}>
        <h2 className={styles.largeHeadline}>{headline.toUpperCase()}</h2>
        <CandidateSocialButtons
          containerStyle={styles.socialsContainer}
          iconContainerStyle={styles.socialsContainer_img}
          loader={loader}
          url={url}
          anchor={anchor}
          toolTipId={"toolTip_Default"}
        />
      </div>
      <a className={styles.navArrowLeft} onClick={() => scroll(type, 'left')}>
        { (data.gaffes?.length > 3 || data.quotes?.length > 4) &&
          <div className={styles.left}>
            <Image
              loader={loader}
              src={arrowPrev}
              alt={data.first_name}
              layout="fixed"
              width={15}
              height={15}
            />
          </div>
        }
      </a>

      <a className={styles.navArrowRight} onClick={() => scroll(type, 'right')}>
        { (data.gaffes?.length > 3 || data.quotes?.length > 4) &&
          <div className={styles.right}>
            <Image
              loader={loader}
              src={arrowNext}
              alt={data.first_name}
              layout="fixed"
              width={15}
              height={15}
            />
          </div>
        }
      </a>
      <div id={`${type}Carousel`} className={styles.carousel}>
        {
          type === 'quotes' && data && data.quotes && Array.from(Array(Math.ceil(data.quotes.length / 4))).map((e, page) => 
            <div key={page} className={`${styles.quotes} ${Math.abs(data.quotes.length - (page * 4)) <= 2 ? styles.quotes__centered : ''}`}>
              { data && data.quotes && data.quotes.map((quote, index) => 
                (index >= (page * 4) && index < (page * 4) + 4) && <div key={index} className={styles.people}>
                  <div className={styles.details}>
                    <div className={styles.avatar}>
                    {quote.thumbnail ? (
                      <Image
                        src={quote.thumbnail}
                        alt={quote.person}
                        layout="fixed"
                        width={60}
                        height={60}
                        className={styles.avatar}
                      />
                    ) : (
                      <Image
                        loader={loader}
                        src={GenericMaleThumbnail}
                        alt="default image"
                        layout="fixed"
                        width={60}
                        height={60}
                        className={styles.avatar}
                      />
                    )}
                    </div>
                    <div className={quote.title ? styles.name : styles.noTitle}>
                      {quote.person}
                      <div className={styles.title}>
                        {quote.title}
                      </div>
                    </div>
                  </div>
                  <div className={styles.quoteMark}>
                    <svg width="60" height="42" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M56.5517 42L58.6207 34.4577C54.1379 34.3592 51.2644 33.0775 50 30.6127C48.7356 28.1479 48.1034 24.993 48.1034 21.1479H60V0H35.3448C35.3448 2.95775 35.4023 5.81691 35.5172 8.57747C35.5172 11.338 35.5747 13.9507 35.6897 16.4155C36.0345 24.8944 37.6437 31.2535 40.5172 35.493C43.2759 39.7324 48.6207 41.9014 56.5517 42ZM21.2069 42L23.2759 34.4577C18.7931 34.3592 15.9195 33.0775 14.6552 30.6127C13.3908 28.1479 12.7586 24.993 12.7586 21.1479H24.6552V0H9.12692e-08C9.12692e-08 2.95775 0.0574743 5.81691 0.172419 8.57747C0.172419 11.338 0.229887 13.9507 0.344828 16.4155C0.689655 24.8944 2.29885 31.2535 5.17242 35.493C7.93104 39.7324 13.2759 41.9014 21.2069 42Z" fill="#F04F3C"/>
                    </svg>
                  </div>
                  <div className={styles.message}>
                    <p>{quote.message}</p>
                    { quote.source && quote.source.url &&
                      <div className={styles.footNote}>
                        <p>
                          <Link href={quote.source.url} passHref>
                            {quote.source.date}
                          </Link>
                        </p>
                      </div>
                    }
                  </div>
                </div>
              )}
            </div>
          )
        }
        {
          type === 'gaffesAndBlunders' && data && data.gaffes && Array.from(Array(Math.ceil(data.gaffes.length / 3))).map((e, page) => 
            <div key={page} className={styles.gaffesAndBlunders}>
              { data && data.gaffes && data.gaffes.map((gaffe, index) => 
                (index >= (page * 3) && index < (page * 3) + 3) && <div key={index} className={styles.content}>
                  <div className={styles.quoteMark}>
                    <svg width="60" height="42" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M56.5517 42L58.6207 34.4577C54.1379 34.3592 51.2644 33.0775 50 30.6127C48.7356 28.1479 48.1034 24.993 48.1034 21.1479H60V0H35.3448C35.3448 2.95775 35.4023 5.81691 35.5172 8.57747C35.5172 11.338 35.5747 13.9507 35.6897 16.4155C36.0345 24.8944 37.6437 31.2535 40.5172 35.493C43.2759 39.7324 48.6207 41.9014 56.5517 42ZM21.2069 42L23.2759 34.4577C18.7931 34.3592 15.9195 33.0775 14.6552 30.6127C13.3908 28.1479 12.7586 24.993 12.7586 21.1479H24.6552V0H9.12692e-08C9.12692e-08 2.95775 0.0574743 5.81691 0.172419 8.57747C0.172419 11.338 0.229887 13.9507 0.344828 16.4155C0.689655 24.8944 2.29885 31.2535 5.17242 35.493C7.93104 39.7324 13.2759 41.9014 21.2069 42Z" fill="#F04F3C"/>
                    </svg>
                  </div>
                  <div className={styles.message}>
                  {
                    gaffe.quote.split('<br>').map((text) => text ? <p>{text}<br/></p> : <br/>)
                  }
                  </div>
                  <div className={styles.source}>
                  {
                    gaffe.context.split('<br>').map((text) => text ? <p>{text}<br/></p> : <br/>)
                  }
                  { gaffe.source && gaffe.source.url &&
                    <div className={styles.footNote}>
                      <p>
                        <Link href={gaffe.source.url} passHref>
                          {gaffe.source.date}
                        </Link>
                      </p>
                    </div>
                  }
                  </div> 
                </div>
              )}
            </div>
          )
        }
      </div>
      <div className={styles.nonCarousel}>
        <div className={type === 'quotes' ? styles.quotes : styles.gaffesAndBlunders}>
          { type === 'quotes' && data && data.quotes && data.quotes.map((quote, index) => 
            <div key={index} className={styles.people}>
              <div className={styles.details}>
                <div className={styles.avatar}>
                {quote.thumbnail ? (
                  <Image
                    src={quote.thumbnail}
                    alt={quote.person}
                    layout="fixed"
                    width={60}
                    height={60}
                    className={styles.avatar}
                  />
                ) : (
                  <Image
                    loader={loader}
                    src={GenericMaleThumbnail}
                    alt="default image"
                    layout="fixed"
                    width={60}
                    height={60}
                    className={styles.avatar}
                  />
                )}
                </div>
                <div className={quote.title ? styles.name : styles.noTitle}>
                  {quote.person}
                  <div className={styles.title}>
                    {quote.title}
                  </div>
                </div>
              </div>
              <div className={styles.quoteMark}>
                <svg width="60" height="42" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M56.5517 42L58.6207 34.4577C54.1379 34.3592 51.2644 33.0775 50 30.6127C48.7356 28.1479 48.1034 24.993 48.1034 21.1479H60V0H35.3448C35.3448 2.95775 35.4023 5.81691 35.5172 8.57747C35.5172 11.338 35.5747 13.9507 35.6897 16.4155C36.0345 24.8944 37.6437 31.2535 40.5172 35.493C43.2759 39.7324 48.6207 41.9014 56.5517 42ZM21.2069 42L23.2759 34.4577C18.7931 34.3592 15.9195 33.0775 14.6552 30.6127C13.3908 28.1479 12.7586 24.993 12.7586 21.1479H24.6552V0H9.12692e-08C9.12692e-08 2.95775 0.0574743 5.81691 0.172419 8.57747C0.172419 11.338 0.229887 13.9507 0.344828 16.4155C0.689655 24.8944 2.29885 31.2535 5.17242 35.493C7.93104 39.7324 13.2759 41.9014 21.2069 42Z" fill="#F04F3C"/>
                </svg>
              </div>
              <div className={styles.message}>
                <p>{quote.message}</p>
                { quote.source && quote.source.url &&
                  <div className={styles.footNote}>
                    <p>
                      <Link href={quote.source.url} passHref>
                        {quote.source.date}
                      </Link>
                    </p>
                  </div>
                }
              </div>  
            </div>
          )}
          { data && data.gaffes && data.gaffes.map((gaffe, index) => 
            <div key={index} className={styles.content}>
              <div className={styles.quoteMark}>
                <svg width="60" height="42" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M56.5517 42L58.6207 34.4577C54.1379 34.3592 51.2644 33.0775 50 30.6127C48.7356 28.1479 48.1034 24.993 48.1034 21.1479H60V0H35.3448C35.3448 2.95775 35.4023 5.81691 35.5172 8.57747C35.5172 11.338 35.5747 13.9507 35.6897 16.4155C36.0345 24.8944 37.6437 31.2535 40.5172 35.493C43.2759 39.7324 48.6207 41.9014 56.5517 42ZM21.2069 42L23.2759 34.4577C18.7931 34.3592 15.9195 33.0775 14.6552 30.6127C13.3908 28.1479 12.7586 24.993 12.7586 21.1479H24.6552V0H9.12692e-08C9.12692e-08 2.95775 0.0574743 5.81691 0.172419 8.57747C0.172419 11.338 0.229887 13.9507 0.344828 16.4155C0.689655 24.8944 2.29885 31.2535 5.17242 35.493C7.93104 39.7324 13.2759 41.9014 21.2069 42Z" fill="#F04F3C"/>
                </svg>
              </div>
              <div className={styles.message}>
                {
                  gaffe.quote.split('<br>').map((text) => text ? <p>{text}<br/></p> : <br/>)
                }
              </div>
              <div className={styles.source}>
                {
                  gaffe.context.split('<br>').map((text) => text ? <p>{text}<br/></p> : <br/>)
                }
                { gaffe.source && gaffe.source.url &&
                  <div className={styles.footNote}>
                    <p>
                      <Link href={gaffe.source.url} passHref>
                        {gaffe.source.date}
                      </Link>
                    </p>
                  </div>
                }
              </div>
            </div>
          )}
          <div className={styles.gapFiller} />
        </div>
      </div>
    </div>
  ) : null
}

export default CandidateTestimonialSection;